// extracted by mini-css-extract-plugin
module.exports = {"lnkReturn":"returnStart_lnkReturn__2OdQA"};